export const interestedByMapping = Object.freeze({
    interestedBy: 'specific.interestedBy'
});
